import styled from 'styled-components';
import { MuiBox, MuiContainer, MuiGrid } from 'theme/material-ui';
import { BorderRadius } from 'modules/styles/variables';

export const StyledSocialSecurityAlert = styled(MuiBox)`
  border: 1px solid #b5d4f3;
  border-radius: ${BorderRadius.small}px;
  background-color: #e2edfa;
`;

export const ProfileContainer = styled(MuiContainer)`
  padding: 24px 0px 24px 0px;
`;

export const MuiGridPanel = styled(MuiGrid)`
  padding-left: 42px;
`;
